import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import { SendNotification } from './types'

class SystemApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  triggerEvent = (payload: SendNotification) =>
    this.api.post(`/yoda/internal/v1/system`, payload)

  getSystemGenieData = async (payload: any) => {
    return this.api.post<any>(
      '/gw2/yoda/internal/v1/genie/job/fetch-store-tags',
      payload,
    )
  }
}

export default SystemApi
